var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page",
      attrs: { id: "app" },
      on: {
        "modal-open": function($event) {
          return _vm.openModal()
        }
      }
    },
    [
      _c("navigation-component"),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "main-content" },
        [
          _c(
            "transition",
            { attrs: { name: "page", mode: "out-in" } },
            [
              _c(
                "keep-alive",
                { key: _vm.$route.meta.id },
                [_c("router-view", { key: _vm.$route.meta.id })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.pageLoading
          ? _c("div", { staticClass: "pageLoader" }, [
              _c("div", { staticClass: "pageLoader__body" }, [
                _c("div", { staticClass: "loader" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "circular",
                      attrs: { viewBox: "25 25 50 50" }
                    },
                    [
                      _c("circle", {
                        staticClass: "path",
                        attrs: {
                          cx: "50",
                          cy: "50",
                          r: "20",
                          fill: "none",
                          "stroke-width": "2",
                          "stroke-miterlimit": "10"
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("footer-component", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.pageLoading,
            expression: "!pageLoading"
          }
        ]
      }),
      _vm._v(" "),
      _vm.modal.component
        ? _c(_vm.modal.component, {
            tag: "component",
            attrs: { open: _vm.modal.isOpen },
            on: {
              "update:open": function($event) {
                return _vm.$set(_vm.modal, "isOpen", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6fa670", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6fa670","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/App.vue
// module id = 266
// module chunks = 17